var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"form-group"},[_c('v-row',{staticClass:"form-group-row top"},[_vm._t("top")],2),_vm._t("bottom")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }